/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

const AppSubmenu = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const onMenuItemClick = (event, item, index) => {
    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    // execute command
    if (item.command) {
      item.command({
        originalEvent: event,
        item,
      });
    }

    if (index === activeIndex) setActiveIndex(null);
    else setActiveIndex(index);

    if (props.onMenuItemClick) {
      props.onMenuItemClick({
        originalEvent: event,
        item,
      });
    }
    return true
  };

  const renderLinkContent = (item) => {
    const submenuIcon = item.items && (
      <i className="pi pi-fw pi-angle-down menuitem-toggle-icon" />
    );
    const badge = item.badge && (
      <span className="menuitem-badge"> {item.badge} </span>
    );

    return (
      <>
        <i className={item.icon} /> <span> {item.label} </span> {submenuIcon}{' '}
        {badge}{' '}
      </>
    );
  };

  const renderLink = (item, i) => {
    const content = renderLinkContent(item);

    if (item.to) {
      return (
        <NavLink
          activeClassName="active-route"
          to={item.to}
          onClick={(e) => onMenuItemClick(e, item, i)}
          exact
          target={item.target}
        >
          {' '}
          {content}{' '}
        </NavLink>
      );
    }
    return (
      <a
        href={item.url}
        onClick={(e) => onMenuItemClick(e, item, i)}
        target={item.target}
      >
        {' '}
        {content}{' '}
      </a>
    );
  };

  const items =
    props.items &&
    props.items.map((item, i) => {
      const active = activeIndex === i;
      const styleClass = classNames(item.badgeStyleClass, {
        'active-menuitem': active && !item.to,
      });

      return (
        // eslint-disable-next-line react/no-array-index-key
        <li className={styleClass} key={`menu-${i}`}>
          {item.items && props.root === true && <div className="arrow" />}
          {renderLink(item, i)}
          <CSSTransition
            classNames="p-toggleable-content"
            timeout={{ enter: 1000, exit: 450 }}
            in={active}
            unmountOnExit
          >
            <AppSubmenu
              items={item.items}
              onMenuItemClick={props.onMenuItemClick}
            />
          </CSSTransition>
        </li>
      );
    });

  return items ? <ul className={props.className}>{items}</ul> : null;
};

const AppMenu = (props) => (
  <div className="layout-menu-container">
    <AppSubmenu
      items={props.model}
      className="layout-menu"
      onMenuItemClick={props.onMenuItemClick}
      root
    />
  </div>
);

export default AppMenu;
